/** @file Returns the bones/slots/ik timelines of one animation draft as plain target → track records. */
import type { Draft } from 'immer';
import type { Doc, Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import type { ChannelSpec, KeyTrack } from './keyChannels';

/** The `group` timelines of animation `animId` (NOT_FOUND when the animation is missing). */
export function keyGroup(draft: Draft<Doc>, animId: Id, group: ChannelSpec['group']): Record<Id, KeyTrack | undefined> {
  const anim = draft.animations[animId] ?? throwError('NOT_FOUND', { kind: 'animation', ref: animId });
  return anim[group];
}
